var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import OfferingsFilterTab from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsFilterTab/OfferingsFilterTab";
import { EMFFilterType, } from "@domains/features/Markets/MutualFunds/entities/MutualFundsSchemesEntity";
import OfferingsCheckboxListFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsCheckboxListFilters/OfferingsCheckboxListFilters";
import OfferingsRangeFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsRangeFilters/OfferingsRangeFilters";
import OfferingsSortTab from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsSortTab/OfferingsSortTab";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/SwitchAndSTP/SwitchAndSTP.scss";
import { removeEmptyKeyValuesPairs } from "@domains/utils/validation";
import { SwitchFundsFilterSortList, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import OfferingsRadioListFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsRadioListFilters/OfferingsRadioListFilters";
var SwitchAndSTPFilters = function (props) {
    var _a, _b;
    // *******************************************
    // *           useStates                 *
    // *******************************************
    var _c = __read(useState(false), 2), isShowFilterPopup = _c[0], setIsShowFilterPopup = _c[1];
    var _d = __read(React.useState([]), 2), switchTransferFilterTabsList = _d[0], setswitchTransferFilterTabsList = _d[1];
    var _e = __read(React.useState((switchTransferFilterTabsList === null || switchTransferFilterTabsList === void 0 ? void 0 : switchTransferFilterTabsList.length)
        ? (_b = (_a = switchTransferFilterTabsList[0]) === null || _a === void 0 ? void 0 : _a.eventKey) === null || _b === void 0 ? void 0 : _b.toString()
        : ""), 2), filterTabActiveKey = _e[0], setFilterTabActiveKey = _e[1];
    var _f = __read(useState(__assign({}, props.mutualFundFilterSortValues)), 2), localAppliedFilterState = _f[0], setLocalAppliedFilterState = _f[1];
    var _g = __read(React.useState({}), 2), selectedFiltersData = _g[0], setSelectedFiltersData = _g[1];
    var _h = __read(React.useState({}), 2), filterFieldsErrors = _h[0], setFilterFieldsErrors = _h[1];
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    var generateSpecificTabContent = function (filterType, metaData) {
        switch (filterType) {
            case EMFFilterType.CHECKBOX:
                var keyName = metaData.value;
                return (React.createElement(OfferingsCheckboxListFilters, { key: keyName, displayDataList: metaData.list, 
                    // filterDataList={props.filterDisplayData[metaData.value].list}
                    enableSearch: metaData.enableSearchForFilter, selectedValuesList: selectedFiltersData, onChangeCallback: onCheckBoxChange, parentKeyName: metaData.value, parentClassName: "rating-columns-filter", loader: props === null || props === void 0 ? void 0 : props.switchTransferFundsFilterLoader }));
            case EMFFilterType.RANGE:
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: metaData.value, onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: localAppliedFilterState, errorData: filterFieldsErrors, inputLimit: metaData === null || metaData === void 0 ? void 0 : metaData.maxInputLength, inputPlaceholder: metaData === null || metaData === void 0 ? void 0 : metaData.placeholder, showInputSuffix: metaData === null || metaData === void 0 ? void 0 : metaData.showSuffixInInput }));
            case EMFFilterType.NESTED_RADIO:
                return generateNestedRadioFilterComp(metaData);
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var generateNestedRadioFilterComp = function (metaData) {
        return metaData.nestedFilters.map(function (item) {
            var _a, _b;
            var isSchemeType = item.title == "Scheme Type";
            return (React.createElement("div", { className: "bg-ghost-white3" },
                React.createElement("span", { className: "d-block txt_rhythm DMSansMedium_15_500 px-16 py-12" }, item.title),
                React.createElement(OfferingsRadioListFilters, { filterDataList: item.list, selectedRadioValue: isSchemeType
                        ? ((_a = localAppliedFilterState === null || localAppliedFilterState === void 0 ? void 0 : localAppliedFilterState.schPlan) === null || _a === void 0 ? void 0 : _a.length) > 0
                            ? localAppliedFilterState.schPlan[0]
                            : null
                        : ((_b = localAppliedFilterState === null || localAppliedFilterState === void 0 ? void 0 : localAppliedFilterState.schType) === null || _b === void 0 ? void 0 : _b.length) > 0
                            ? localAppliedFilterState.schType[0]
                            : null, onChangeCallback: function (e) {
                        onRadioBtnChange(e, isSchemeType);
                    } })));
        });
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    // functions related to filter
    var handleOnClick = function () {
        setIsShowFilterPopup(!isShowFilterPopup);
    };
    var handleCancelApplyingFilter = function () {
        setIsShowFilterPopup(false);
        var localMasterFilterSortValues = removeEmptyKeyValuesPairs(props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues);
        var localSelectedFiltersData = {};
        Object.keys(localMasterFilterSortValues).forEach(function (filterKey) {
            // localSelectedFiltersData[filterKey]={}
            if (Array.isArray(localMasterFilterSortValues[filterKey])) {
                localMasterFilterSortValues[filterKey].forEach(function (filterVal) {
                    var _a;
                    localSelectedFiltersData[filterKey] = __assign(__assign({}, localSelectedFiltersData[filterKey]), (_a = {}, _a[filterVal] = {
                        filterValue: filterVal,
                    }, _a));
                    // = {[filterVal]:{}}
                });
            }
        });
        handleUpdateSelectedFiltersState(localSelectedFiltersData);
        setLocalAppliedFilterState(props.mutualFundFilterSortValues);
        // setLocalMutualFundFilterSortValues({
        //   ...JSON.parse(JSON.stringify(masterFilterSortData)),
        // });
    };
    var handleClearAllFiltersCallback = function () {
        props.onFilterSelectionCallback({});
        setSelectedFiltersData({});
        setLocalAppliedFilterState({});
        setIsShowFilterPopup(false);
    };
    var handleFilterTabChange = function (selectedKey, e) {
        e.stopPropagation();
        setFilterTabActiveKey(selectedKey);
    };
    var handleFilterPopupTabChange = function (selectedKey, e) {
        e.stopPropagation();
    };
    var handleApplyFilterCallback = function () {
        var keys = filterFieldsErrors ? Object.keys(filterFieldsErrors) : [];
        if (keys.length > 0 &&
            keys.findIndex(function (item) { return item === filterTabActiveKey; }) === -1)
            setFilterTabActiveKey(keys[0]);
        // validation checks
        // const currentActiveTab = handleFindCurrentActiveTabFromList();
        var filterValues = __assign({}, localAppliedFilterState);
        var validatedFilterData = handleValidateFilterFields(filterValues);
        if (validatedFilterData.validationsPassed) {
            // handleUpdateMasterSortFilterValuesState(
            //   validatedFilterData.localFilterData
            // );
            setLocalAppliedFilterState(validatedFilterData.localFilterData);
            props.onFilterSelectionCallback(localAppliedFilterState);
            setIsShowFilterPopup(false);
        }
    };
    var handleValidateFilterFields = function (filterData) {
        var localFilterData = __assign({}, filterData);
        var filterTabKeys = Object.keys(props.filterDisplayData);
        var localFilterErrorObject = __assign({}, filterFieldsErrors);
        filterTabKeys.forEach(function (key) {
            var filterTabObj = props.filterDisplayData[key];
            var localFilterValues = localFilterData[filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.value];
            if ((filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.shouldValidate) && !!localFilterValues) {
                var localStaticFilters = localFilterValues;
                if ((!!localStaticFilters.operator && !localStaticFilters.value) ||
                    (!!localStaticFilters.value && !localStaticFilters.operator)) {
                    if (!localStaticFilters.value) {
                        localFilterErrorObject[filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.value] = {
                            inputError: "This field is required",
                        };
                    }
                    if (!localStaticFilters.operator) {
                        localFilterErrorObject[filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.value] = {
                            selectError: "This field is required",
                        };
                    }
                }
                else if (!localStaticFilters.value || !localStaticFilters.operator) {
                    delete localFilterErrorObject[filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.value];
                    delete localFilterData[filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.value];
                }
                else {
                    delete localFilterErrorObject[filterTabObj === null || filterTabObj === void 0 ? void 0 : filterTabObj.value];
                }
            }
        });
        setFilterFieldsErrors(localFilterErrorObject);
        return {
            validationsPassed: !Object.keys(localFilterErrorObject).length,
            localFilterData: localFilterData,
        };
    };
    // const handleFindCurrentActiveTabFromList = () => {
    //   return props?.tabList?.find(
    //     (item) => item?.title.toLowerCase() === tab?.toLowerCase()
    //   );
    // };
    var handleUpdateSelectedFiltersState = function (data) {
        setSelectedFiltersData(data);
    };
    var handleSortTabDataChange = function (e, item) {
        localAppliedFilterState["sortColumn"] = item.value;
        localAppliedFilterState["sortOrder"] = item.type;
        props.onFilterSelectionCallback(__assign({}, localAppliedFilterState));
    };
    var onCheckBoxChange = function (data) {
        var _a;
        (_a = Object.keys(data)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            localAppliedFilterState[key] =
                Object.keys(data[key]).map(function (item) {
                    return item;
                });
        });
        handleUpdateSelectedFiltersState(data);
        setLocalAppliedFilterState(__assign({}, localAppliedFilterState));
        // !!props?.onFilterSelectionCallback &&
        //   props.onFilterSelectionCallback({ ...localAppliedFilterState });
    };
    var onDropDownChange = function (data, param) {
        var _a;
        var localObj = __assign({}, localAppliedFilterState);
        var localFilterData = localObj[param];
        if (localFilterData) {
            localObj[param] = data.value;
        }
        else {
            localObj = __assign(__assign({}, localObj), (_a = {}, _a[param] = data.value, _a));
        }
        setLocalAppliedFilterState(__assign({}, localObj));
        // props.onFilterSelectionCallback({
        //   ...localObj,
        // });
    };
    var onInputFormChange = function (name, vale, param
    // &
    //   ("year1" | "year3" | "year5" | "fundSize" | "expenseRatio")
    ) {
        var _a;
        setLocalAppliedFilterState(__assign(__assign({}, localAppliedFilterState), (_a = {}, _a[param] = __assign(__assign({}, localAppliedFilterState[param]), { value: vale }), _a)));
        // props.onFilterSelectionCallback({
        //   ...localAppliedFilterState,
        //   [param]: { ...localAppliedFilterState[param], value: vale },
        // });
    };
    var onRadioBtnChange = function (e, isSchemeType) {
        if (isSchemeType) {
            localAppliedFilterState["schPlan"] = [e.target.value];
        }
        else {
            localAppliedFilterState["schType"] = [e.target.value];
        }
        setLocalAppliedFilterState(__assign({}, localAppliedFilterState));
    };
    // *******************************************
    // *           Constants                     *
    // *******************************************
    var setShow = function () {
        setIsShowFilterPopup(true);
    };
    var createFilterTabList = function () {
        var filterTabs = Object.keys(props.filterDisplayData).map(function (key) {
            var obj = props.filterDisplayData[key];
            if (!!obj) {
                return {
                    title: obj.title,
                    eventKey: obj.value,
                    tabContent: generateSpecificTabContent(obj.filterType, obj),
                };
            }
        });
        setswitchTransferFilterTabsList(filterTabs);
    };
    // *******************************************
    // *           UseEffects                    *
    // *******************************************
    React.useEffect(function () {
        if (!!props.filterDisplayData) {
            createFilterTabList();
        }
    }, [
        props.filterDisplayData,
        localAppliedFilterState,
        selectedFiltersData,
        props === null || props === void 0 ? void 0 : props.switchTransferFundsFilterLoader,
        filterFieldsErrors,
    ]);
    useEffect(function () {
        if (!isShowFilterPopup) {
            setFilterFieldsErrors({});
        }
    }, [isShowFilterPopup]);
    // *******************************************
    // *            Rendering                    *
    // *******************************************
    return (React.createElement(GenericPopup, { placement: "bottom-end", isHeadline: true, isShow: isShowFilterPopup, setIsShow: setShow, removeTooltipArrow: true, parentClass: "switch-funds-filter-pop-up", containerDom: function () { return document.getElementById("switch-fund-filter-btn"); }, buttonOnClick: handleOnClick, button: React.createElement("div", { className: "position-relative" },
            React.createElement(EdButtonIcon, { id: "switch-fund-filter-btn", btnIcon: "edel-icon-filter-1", btnTyp: "link", className: "custom-filter", slim: true, paths: 3 }),
            props.hasAppliedFilterValues && (React.createElement("span", { className: "filter-selected d-flex" }))), children: React.createElement("div", { className: "switch-funds-filters-sort-tabs-primary-container" },
            React.createElement("div", null,
                React.createElement(GenericTabs, { defaultActiveKey: "filter", callBackFunction: handleFilterPopupTabChange, externalClassName: "offerings-sort-filter-tabs", tabsArray: [
                        {
                            title: "Filter",
                            eventKey: "filter",
                            tabContent: (React.createElement(OfferingsFilterTab, { filterTabs: switchTransferFilterTabsList, filterTabActiveKey: filterTabActiveKey, handleFilterTabChange: handleFilterTabChange })),
                            // null,
                        },
                        {
                            title: "Sort",
                            eventKey: "sort",
                            tabContent: (React.createElement(OfferingsSortTab, { filterDataList: SwitchFundsFilterSortList, onChangeCallback: handleSortTabDataChange, selectedRadioValue: localAppliedFilterState === null || localAppliedFilterState === void 0 ? void 0 : localAppliedFilterState.sortColumn })),
                            // null,
                        },
                    ] }),
                React.createElement("div", { className: "filter-sort-clear-btn-wrapper" },
                    React.createElement(EdButton, { btnTyp: "text-only", className: "txt-han-blue DMSanN_14_400", value: "Clear All", onClick: handleClearAllFiltersCallback }))),
            React.createElement("div", { className: "d-flex align-items-center gap-2 justify-content-between offerings-filters-action-buttons-footer bg_white" },
                React.createElement(EdButton, { btnTyp: "text-only", value: "Cancel", onClick: handleCancelApplyingFilter, className: "offerings-custom-button DMSan_14_500 txt-han-blue w-100" }),
                React.createElement(EdButton, { btnTyp: "tomato", value: "Apply", onClick: handleApplyFilterCallback, className: "offerings-custom-button DMSan_14_500 px-40" }))) }));
};
export default SwitchAndSTPFilters;
